const USFlag = () => (
  <svg width="16" height="12" viewBox="0 0 247.5 152.5" style={{ marginRight: '4px', verticalAlign: 'middle' }}>
    {/* Stripes - alternating red and white */}
    <rect width="247.5" height="15.25" fill="#B22234"/>
    <rect y="15.25" width="247.5" height="15.25" fill="#FFFFFF"/>
    <rect y="30.5" width="247.5" height="15.25" fill="#B22234"/>
    <rect y="45.75" width="247.5" height="15.25" fill="#FFFFFF"/>
    <rect y="61" width="247.5" height="15.25" fill="#B22234"/>
    <rect y="76.25" width="247.5" height="15.25" fill="#FFFFFF"/>
    <rect y="91.5" width="247.5" height="15.25" fill="#B22234"/>
    <rect y="106.75" width="247.5" height="15.25" fill="#FFFFFF"/>
    <rect y="122" width="247.5" height="15.25" fill="#B22234"/>
    <rect y="137.25" width="247.5" height="15.25" fill="#FFFFFF"/>

    {/* Blue field - union */}
    <rect width="82.5" height="122" fill="#3C3B6E"/>

    {/* Stars - 50 stars in 9 rows (6-5-6-5-6-5-6-5-6) */}
    <g fill="#FFFFFF">
      {/* Row 1: 6 stars */}
      <polygon points="10,8 11.5,11.5 15,11.5 12.5,14 14,17.5 10,15.5 6,17.5 7.5,14 5,11.5 8.5,11.5"/>
      <polygon points="25,8 26.5,11.5 30,11.5 27.5,14 29,17.5 25,15.5 21,17.5 22.5,14 20,11.5 23.5,11.5"/>
      <polygon points="40,8 41.5,11.5 45,11.5 42.5,14 44,17.5 40,15.5 36,17.5 37.5,14 35,11.5 38.5,11.5"/>
      <polygon points="55,8 56.5,11.5 60,11.5 57.5,14 59,17.5 55,15.5 51,17.5 52.5,14 50,11.5 53.5,11.5"/>
      <polygon points="70,8 71.5,11.5 75,11.5 72.5,14 74,17.5 70,15.5 66,17.5 67.5,14 65,11.5 68.5,11.5"/>

      {/* Row 2: 5 stars */}
      <polygon points="17.5,23 19,26.5 22.5,26.5 20,29 21.5,32.5 17.5,30.5 13.5,32.5 15,29 12.5,26.5 16,26.5"/>
      <polygon points="32.5,23 34,26.5 37.5,26.5 35,29 36.5,32.5 32.5,30.5 28.5,32.5 30,29 27.5,26.5 31,26.5"/>
      <polygon points="47.5,23 49,26.5 52.5,26.5 50,29 51.5,32.5 47.5,30.5 43.5,32.5 45,29 42.5,26.5 46,26.5"/>
      <polygon points="62.5,23 64,26.5 67.5,26.5 65,29 66.5,32.5 62.5,30.5 58.5,32.5 60,29 57.5,26.5 61,26.5"/>

      {/* Row 3: 6 stars */}
      <polygon points="10,38 11.5,41.5 15,41.5 12.5,44 14,47.5 10,45.5 6,47.5 7.5,44 5,41.5 8.5,41.5"/>
      <polygon points="25,38 26.5,41.5 30,41.5 27.5,44 29,47.5 25,45.5 21,47.5 22.5,44 20,41.5 23.5,41.5"/>
      <polygon points="40,38 41.5,41.5 45,41.5 42.5,44 44,47.5 40,45.5 36,47.5 37.5,44 35,41.5 38.5,41.5"/>
      <polygon points="55,38 56.5,41.5 60,41.5 57.5,44 59,47.5 55,45.5 51,47.5 52.5,44 50,41.5 53.5,41.5"/>
      <polygon points="70,38 71.5,41.5 75,41.5 72.5,44 74,47.5 70,45.5 66,47.5 67.5,44 65,41.5 68.5,41.5"/>

      {/* Row 4: 5 stars */}
      <polygon points="17.5,53 19,56.5 22.5,56.5 20,59 21.5,62.5 17.5,60.5 13.5,62.5 15,59 12.5,56.5 16,56.5"/>
      <polygon points="32.5,53 34,56.5 37.5,56.5 35,59 36.5,62.5 32.5,60.5 28.5,62.5 30,59 27.5,56.5 31,56.5"/>
      <polygon points="47.5,53 49,56.5 52.5,56.5 50,59 51.5,62.5 47.5,60.5 43.5,62.5 45,59 42.5,56.5 46,56.5"/>
      <polygon points="62.5,53 64,56.5 67.5,56.5 65,59 66.5,62.5 62.5,60.5 58.5,62.5 60,59 57.5,56.5 61,56.5"/>

      {/* Row 5: 6 stars */}
      <polygon points="10,68 11.5,71.5 15,71.5 12.5,74 14,77.5 10,75.5 6,77.5 7.5,74 5,71.5 8.5,71.5"/>
      <polygon points="25,68 26.5,71.5 30,71.5 27.5,74 29,77.5 25,75.5 21,77.5 22.5,74 20,71.5 23.5,71.5"/>
      <polygon points="40,68 41.5,71.5 45,71.5 42.5,74 44,77.5 40,75.5 36,77.5 37.5,74 35,71.5 38.5,71.5"/>
      <polygon points="55,68 56.5,71.5 60,71.5 57.5,74 59,77.5 55,75.5 51,77.5 52.5,74 50,71.5 53.5,71.5"/>
      <polygon points="70,68 71.5,71.5 75,71.5 72.5,74 74,77.5 70,75.5 66,77.5 67.5,74 65,71.5 68.5,71.5"/>

      {/* Row 6: 5 stars */}
      <polygon points="17.5,83 19,86.5 22.5,86.5 20,89 21.5,92.5 17.5,90.5 13.5,92.5 15,89 12.5,86.5 16,86.5"/>
      <polygon points="32.5,83 34,86.5 37.5,86.5 35,89 36.5,92.5 32.5,90.5 28.5,92.5 30,89 27.5,86.5 31,86.5"/>
      <polygon points="47.5,83 49,86.5 52.5,86.5 50,89 51.5,92.5 47.5,90.5 43.5,92.5 45,89 42.5,86.5 46,86.5"/>
      <polygon points="62.5,83 64,86.5 67.5,86.5 65,89 66.5,92.5 62.5,90.5 58.5,92.5 60,89 57.5,86.5 61,86.5"/>

      {/* Row 7: 6 stars */}
      <polygon points="10,98 11.5,101.5 15,101.5 12.5,104 14,107.5 10,105.5 6,107.5 7.5,104 5,101.5 8.5,101.5"/>
      <polygon points="25,98 26.5,101.5 30,101.5 27.5,104 29,107.5 25,105.5 21,107.5 22.5,104 20,101.5 23.5,101.5"/>
      <polygon points="40,98 41.5,101.5 45,101.5 42.5,104 44,107.5 40,105.5 36,107.5 37.5,104 35,101.5 38.5,101.5"/>
      <polygon points="55,98 56.5,101.5 60,101.5 57.5,104 59,107.5 55,105.5 51,107.5 52.5,104 50,101.5 53.5,101.5"/>
      <polygon points="70,98 71.5,101.5 75,101.5 72.5,104 74,107.5 70,105.5 66,107.5 67.5,104 65,101.5 68.5,101.5"/>

      {/* Row 8: 5 stars */}
      <polygon points="17.5,113 19,116.5 22.5,116.5 20,119 21.5,122.5 17.5,120.5 13.5,122.5 15,119 12.5,116.5 16,116.5"/>
      <polygon points="32.5,113 34,116.5 37.5,116.5 35,119 36.5,122.5 32.5,120.5 28.5,122.5 30,119 27.5,116.5 31,116.5"/>
      <polygon points="47.5,113 49,116.5 52.5,116.5 50,119 51.5,122.5 47.5,120.5 43.5,122.5 45,119 42.5,116.5 46,116.5"/>
      <polygon points="62.5,113 64,116.5 67.5,116.5 65,119 66.5,122.5 62.5,120.5 58.5,122.5 60,119 57.5,116.5 61,116.5"/>
    </g>
  </svg>
);

export default USFlag;
